// extracted by extract-css-chunks-webpack-plugin
module.exports = {"close-btn":"preview-modal__close-btn___3AW4H","closeBtn":"preview-modal__close-btn___3AW4H"};
    if(module.hot) {
      // 1770085538276
      var cssReload = require("../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  